import React from 'react';
import { useCart } from '../../context/CartContext';
import { useNavigate } from 'react-router-dom';
import { formatPrice } from '../../utils/formatPrice';
import { ShoppingCart } from 'lucide-react';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { Badge } from '../ui/badge';

const Cart = () => {
  const { cart } = useCart();
  const navigate = useNavigate();
  
  const totalItems = cart?.items?.length || 0;
  const totalAmount = cart?.total || 0;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="secondary"
          size="sm"
          className="flex items-center gap-2 relative"
        >
          <ShoppingCart className="h-4 w-4" />
          <span className="hidden md:inline">Varukorg</span>
          {totalItems > 0 && (
            <Badge variant="default" className="h-5 px-1.5 text-xs">
              {totalItems}
            </Badge>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80">
        <div className="px-2 py-1.5">
          <p className="text-sm font-semibold">Varukorg</p>
          <p className="text-xs text-muted-foreground">
            {totalItems === 0 ? 'Din varukorg är tom' : `${totalItems} ${totalItems === 1 ? 'artikel' : 'artiklar'}`}
          </p>
        </div>
        
        {totalItems > 0 && (
          <>
            <DropdownMenuSeparator />
            
            {/* Cart Items Preview */}
            <div className="max-h-60 overflow-y-auto px-2 py-1">
              {cart.items.map((item, index) => (
                <div key={index} className="flex items-start gap-3 py-2">
                  {item.previewImage && (
                    <img 
                      src={item.previewImage} 
                      alt={item.car?.name || 'Car preview'} 
                      className="w-16 h-16 object-contain rounded bg-secondary"
                    />
                  )}
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium truncate">{item.car?.name || 'Bil'}</p>
                    <p className="text-xs text-muted-foreground">
                      {Object.values(item.design).flat().length} {Object.values(item.design).flat().length === 1 ? 'dekal' : 'dekaler'}
                    </p>
                    <p className="text-sm font-semibold mt-1">
                      {formatPrice(item.totalCost)} kr
                    </p>
                  </div>
                </div>
              ))}
            </div>
            
            <DropdownMenuSeparator />
            
            {/* Total */}
            <div className="px-2 py-2 flex items-center justify-between">
              <span className="text-sm font-semibold">Totalt:</span>
              <span className="text-sm font-bold">
            {formatPrice(totalAmount)} kr
          </span>
            </div>
            
            <DropdownMenuSeparator />
          </>
        )}
        
        {/* Actions */}
        <div className="p-2 space-y-1">
          <DropdownMenuItem 
            onSelect={() => navigate('/cart')}
            className="cursor-pointer"
          >
            <ShoppingCart className="mr-2 h-4 w-4" />
            <span>Visa varukorg</span>
          </DropdownMenuItem>
    </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default Cart; 